import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { switchMap, map, filter, distinctUntilChanged } from 'rxjs/operators';
import { SignService, Sign } from '../sign.service';

const isSign = (sign: Sign | string | undefined): sign is Sign =>
  !!(sign && typeof sign === 'object');

@Component({
  selector: 'sign-search',
  templateUrl: './sign-search.component.html',
  styleUrls: ['./sign-search.component.scss']
})
export class SignSearchComponent implements OnInit {
  @Output()
  signChange = new EventEmitter<Sign | undefined>();

  search = new FormControl(undefined);

  filteredOptions: Observable<Array<Sign>> | undefined;

  constructor(private signs: SignService) {}

  ngOnInit() {
    this.filteredOptions = this.search.valueChanges.pipe(
      map((value: Sign | string | undefined) =>
        value === undefined || typeof value === 'string' ? value : value.name
      ),
      switchMap(value => (value ? this.filter(value) : of([])))
    );

    this.search.valueChanges
      .pipe(
        map(
          (sign: Sign | string | undefined): Sign | undefined =>
            isSign(sign) ? sign : undefined
        ),
        distinctUntilChanged(),
      )
      .subscribe(this.signChange);
  }

  signName(sign?: Sign): string | undefined {
    return sign ? sign.name : undefined;
  }

  private filter(value: string): Observable<Array<Sign>> {
    return this.signs.filterSigns(value);
  }
}
